import { render, staticRenderFns } from "./alertItem.vue?vue&type=template&id=09988acb&"
import script from "./alertItem.vue?vue&type=script&lang=js&"
export * from "./alertItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports